const SearchIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.58366 18.1244C4.87533 18.1244 1.04199 14.291 1.04199 9.58268C1.04199 4.87435 4.87533 1.04102 9.58366 1.04102C14.292 1.04102 18.1253 4.87435 18.1253 9.58268C18.1253 14.291 14.292 18.1244 9.58366 18.1244ZM9.58366 2.29102C5.55866 2.29102 2.29199 5.56602 2.29199 9.58268C2.29199 13.5994 5.55866 16.8744 9.58366 16.8744C13.6087 16.8744 16.8753 13.5994 16.8753 9.58268C16.8753 5.56602 13.6087 2.29102 9.58366 2.29102Z"
            />
            <path
                d="M18.3335 18.9576C18.1752 18.9576 18.0169 18.8992 17.8919 18.7742L16.2252 17.1076C15.9835 16.8659 15.9835 16.4659 16.2252 16.2242C16.4669 15.9826 16.8669 15.9826 17.1085 16.2242L18.7752 17.8909C19.0169 18.1326 19.0169 18.5326 18.7752 18.7742C18.6502 18.8992 18.4919 18.9576 18.3335 18.9576Z"
            />
        </svg>
    )
}

export default SearchIcon